import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { Card, CardBody, Row } from 'reactstrap';
import { TextInput } from '../../lib/components/textInput';
import { TextInputPassword } from '../../lib/components/textInputPassword';
import { SizeMe } from 'react-sizeme';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

/* Object Json */
import { safeDeepGetWithType } from 'iotera-base/json';
import { withRouter } from 'react-router-dom';

import './style.scss';
import { SubViewHeader } from '../../lib/components/subHeader';
import { IoteraForm } from '../../lib/components/form';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const ADD = "ADD";
const INIT_ROLES = "INIT_ROLES";
const WKEY = "USER_ADD";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

// validation for string
function accessValidation(access) {
  let dropdownItem = [];
  for (let i = 0; i < access.length; i++) {
    dropdownItem.push(
      {
        type: 'string',
        enum: [
          access[i].id
        ],
        title: access[i].name
      }
    )
  }
  return dropdownItem;
}

function schema(access) {
  return {
    "definitions": {
      "Roles": {
        "title": "Role",
        "type": "string",
        "anyOf": accessValidation(access)
      }
    },
    type: "object",
    required: ["username", "first", "email", "pass", "passv", "role_id"],
    properties: {
      username: { type: "string", minLength: 4, maxLength: 16 },
      first: { type: "string", minLength: 4, maxLength: 16 },
      last: { type: "string", maxLength: 16 },
      email: { type: "string", minLength: 4 },
      pass: { type: "string", minLength: 4 },
      passv: { type: "string", minLength: 4 },
      role_id: {
        "$ref": "#/definitions/Roles",
        "title": "Role"
      },
    }
  }
};

const uiSchema = {
  username: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="username"
          type="text"
          label="Username"
          placeholder="Username"
          textTooltip="Masukkan username untuk login pengguna"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  first: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="first"
          type="text"
          label="Nama Depan"
          placeholder="Nama Depan"
          textTooltip="Masukkan nama depan pengguna"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  last: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="last"
          type="text"
          label="Nama Belakang"
          placeholder="Nama Belakang"
          textTooltip="Masukkan nama belakang pengguna"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  email: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="email"
          type="text"
          label="Alamat Email"
          placeholder="Email"
          textTooltip="Masukkan alamat email dari pengguna"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value) /* console.log(event.target) */}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  pass: {
    "ui:widget": (props) => {
      return (
        <TextInputPassword
          id="pass"
          type="text"
          label="Password"
          placeholder="********"
          textTooltip="Masukkan password untuk pengguna ini"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  passv: {
    "ui:widget": (props) => {
      return (
        <TextInputPassword
          id="passv"
          type="text"
          label="Konfirmasi Password"
          placeholder="********"
          textTooltip="Ketik ulang password diatas untuk konfirmasi."
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
};

function Tpl(props) {
  const { id, label, required, children, displayLabel, errors } = props;
  let className = "";
  if (id === 'root_colorMasks' || id === 'root' || id === 'root_colorMask') {
    className = 'myfield';
  }
  if (displayLabel === true) {
    return (
      <div className={className} style={{ marginBottom: '10px' }}>
        <label htmlFor={id}><b>{label}{required ? "*" : null}</b></label>
        {children}
        {errors}
      </div>
    );
  } else {
    return (
      <div className={className} style={{ marginBottom: '10px' }}>
        {children}
        {errors}
      </div>
    );
  }
}

class UserAdd extends Component {
  constructor(props) {
    super(props);
    let widthImage;
    let paddingStyle = '6px 8px';
    let padForm = '0px';
    if (window.innerWidth >= 425) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          paddingStyle = '12px 16px';
          widthImage = '60%';
        } else {
          widthImage = '80%';
        }
        padForm = '17.5px';
      } else {
        widthImage = '30%';
      }
    } else {
      widthImage = '50%';
    }
    this.state = {
      file: 'https://i.imgur.com/8FWamdx.jpg',
      activeTab: '1',
      custom: window.innerWidth <= 574 ? "col-sm-6" : "col-sm-4",
      loading: false,
      formData: {},
      widthImage,
      padForm,
      paddingStyle
    };
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.resize = this.resize.bind(this);
    this.onRemovePicture = this.onRemovePicture.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/account/role/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
          }
        }
      }
    );

    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/manage/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('.' + S + '_user_list_')
                  _props.showSingleNotification({ message: 'Tambah User Sukses', level: 'success' });
                  return;
                }
              } else if (result.code === Result.HTTP.BAD_REQUEST) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -3) {
                  _props.showSingleNotification({ message: 'Username sudah terpakai', position: 'tr', level: 'error' });
                } else if (responseResult === -4) {
                  _props.showSingleNotification({ message: 'Email sudah terpakai', position: 'tr', level: 'error' });
                } else {
                  _props.showSingleNotification({ message: 'Tambah User Gagal', position: 'tr', level: 'error' });
                }
              } else if (result.code === Result.NETWORK_FAILURE) {
                _props.showSingleNotification({
                  message: 'Tidak ada koneksi, cek kembali jaringan internet',
                  position: 'tr', level: 'error'
                });
              } else {
                _props.showSingleNotification({ message: 'Tambah User Gagal', position: 'tr', level: 'error' });
              }
              _this.setState({
                loading: false
              })
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  resize(event) {
    let widthImage;
    let paddingStyle = '6px 8px';
    let padForm = '0px';
    if (window.innerWidth >= 425) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          paddingStyle = '12px 16px';
          widthImage = '60%';
        } else {
          widthImage = '80%';
        }
        padForm = '17.5px';
      } else {
        widthImage = '30%';
      }
    } else {
      widthImage = '50%';
    }
    this.setState({
      custom: window.innerWidth <= 574 ? "col-sm-6" : "col-sm-4",
      widthImage,
      padForm,
      paddingStyle
    })
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    let submitData = event['formData'];
    const username = submitData['username'];
    const email = submitData['email'];
    const pass = submitData['pass'];
    const passv = submitData['passv'];
    const first = submitData['first'];
    const last = submitData['last'];
    const roleId = submitData['role_id'];
    _this.setState({
      formData: submitData,
      loading: true
    })
    _props.wSingleRequestCall({
      id: ADD,
      body: {
        username,
        email,
        pass,
        passv,
        first,
        last,
        role_id: roleId,
        email_verification: false
      }
    });
  }

  handleChange(event) {
    if (event.target.files.length > 0) {
      this.setState({
        file: URL.createObjectURL(event.target.files[0])
      })
    }
  }

  goTo(link) {
    this.props.history.push(link)
  }

  onRemovePicture() {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus gambar ini?',
      'Ya, hapus',
      () => this.setState({
        file: 'https://i.imgur.com/8FWamdx.jpg'
      }),
      null,
      null
    )
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    const { loading, paddingStyle } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let dataToShow = {};
    if (_state.formData === {}) {
      dataToShow = {}
    } else {
      dataToShow = _state.formData;
    }
    let access = safeDeepGetWithType(_props, ['items'], []);
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah Pengguna' subTitle='Permohonan tambah pengguna baru' />
          <div className="io-container mt-12">
            <Row style={{ margin: 0 }}>
              <div className="col-md-4" style={{ paddingRight: 0, paddingLeft: 0 }} >
                <SizeMe >{({ size }) =>
                  <Card className="cobaForm" style={{
                    minWidth: _state.widthImage, maxWidth: _state.widthImage,
                    height: size.width * 4 / 4, maxHeight: size.width * 4 / 4, border: '5px solid white',
                    boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: '50%'
                  }}>
                    <CardBody style={{ margin: 20 }}>
                      <div className="containers" style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
                        <Card className="cardssss" style={{ backgroundColor: '#ffffff', mindWidth: '100%', minHeight: '100%' }}>
                          <CardBody >
                            <Row >
                              <img src={_state.file} alt="Profile" style={{
                                minHeight: '100%', maxHeight: '100%',
                                minWidth: '100%', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0
                              }} />
                            </Row>
                          </CardBody>
                        </Card>
                        {_state.file === 'https://i.imgur.com/8FWamdx.jpg' ?
                          <div className="middle">
                            <Row >
                              <div className="col-md-12">
                                <label className="button-iotera-primary-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}>
                                  <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                  <span>Unggah</span>
                                </label>
                              </div>
                            </Row>
                          </div> :
                          <div className="middle">
                            <Row style={{ marginBottom: 5 }}>
                              <div className="col-md-12">
                                <label className="button-iotera-primary-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}>
                                  <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                  <span>Ganti</span>
                                </label>
                              </div>
                            </Row>
                            <Row>
                              <div className="col-md-12">
                                <button className="button-iotera-red-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}
                                  onClick={(e) => _this.onRemovePicture()} >
                                  Hapus
                                </button>
                              </div>
                            </Row>
                          </div>
                        }
                      </div>
                    </CardBody>
                  </Card>}
                </SizeMe>
              </div>
              <div className="col-md-8" style={{ paddingRight: 0, paddingLeft: 0 }} >
                {access.length > 0 ?
                  <IoteraForm
                    schema={schema(access)}
                    uiSchema={uiSchema}
                    onSubmit={_this.handleSubmit}
                    FieldTemplate={Tpl}
                    formData={dataToShow}
                  >
                    <div className="button-right" style={{ marginTop: 10 }}>
                      <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                        onClick={(e) => _this.goTo('.' + S + '_user_list_')} >Batal</button>
                      <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
                    </div>
                  </IoteraForm>
                  : null}
              </div>
            </Row>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, 'roles')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserAdd));